import { isManualSkuVenue } from 'helpers/ia-logic';

export const SKU_VENUE_SOURCE = Object.freeze({
  MANUAL: 'manual',
  INTEGRATED: 'integrated',
});

// Single classifier for a venue's SKU source. Permissions and analytics both derive from this.
export const getSkuVenueSource = venue =>
  isManualSkuVenue(venue) ? SKU_VENUE_SOURCE.MANUAL : SKU_VENUE_SOURCE.INTEGRATED;
